<p-toast position="top-right" [baseZIndex]="10000"></p-toast>

<div class="flex h-screen bg-gray-50 dark:bg-gray-950">
  <div>
    <app-sidebar></app-sidebar>
    <app-backdrop></app-backdrop>
  </div>
  @if (ui.overlay() && !(isMobileOpen$ | async)) {
    <button
      type="button"
      class="fixed top-4 left-4 z-30 flex h-10 w-10 items-center justify-center rounded-lg border border-gray-200 bg-white text-gray-600 shadow hover:bg-gray-50 dark:border-gray-800 dark:bg-gray-900 dark:text-gray-400 dark:hover:bg-gray-800"
      (click)="openOverlayMenu()"
      aria-label="Abrir menú"
    >
      <svg width="20" height="14" viewBox="0 0 20 14" fill="none" aria-hidden="true">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.5 1C0.5 0.585786 0.835786 0.25 1.25 0.25H18.75C19.1642 0.25 19.5 0.585786 19.5 1C19.5 1.41421 19.1642 1.75 18.75 1.75H1.25C0.835786 1.75 0.5 1.41421 0.5 1ZM0.5 7C0.5 6.58579 0.835786 6.25 1.25 6.25H18.75C19.1642 6.25 19.5 6.58579 19.5 7C19.5 7.41421 19.1642 7.75 18.75 7.75H1.25C0.835786 7.75 0.5 7.41421 0.5 7ZM1.25 12.25C0.835786 12.25 0.5 12.5858 0.5 13C0.5 13.4142 0.835786 13.75 1.25 13.75H18.75C19.1642 13.75 19.5 13.4142 19.5 13C19.5 12.5858 19.1642 12.25 18.75 12.25H1.25Z" fill="currentColor" />
      </svg>
    </button>
  }
  <div
    class="flex-1 overflow-auto transition-all duration-300 ease-in-out"
    [ngClass]="{
      'xl:ml-[290px]': (isExpanded$ | async) || (isHovered$ | async),
      'xl:ml-16': !(isExpanded$ | async) && !(isHovered$ | async),
      'ml-0': (isMobileOpen$ | async)
    }"
  >
    <router-outlet></router-outlet>
  </div>
</div>
